<template>
  <div
    v-if="role === constants.ROLE_SUPER_ADMIN"
    class="lg:mx-5"
  >
    <div class="text-5xl mb-1">
      Bonjour,
    </div>
    <div class="text-gray-600 text-2xl font-light mb-20">
      Que souhaitez-vous faire aujourd'hui ?
    </div>
  </div>
  <div v-else>
    <!-- BEGIN Popup to modify or read job desc and ref formation -->
    <popup-job-desc
      v-if="!isOF"
      v-show="!isROME"
      :show="showJobDesc"
      :id="shownJobId"
      :opened-from-edit-button="true"
      @mutateShow="
        (newValue) => {
          showJobDesc = newValue;
        }
      "
      @mutateId="
        (newValue) => {
          shownJobId = newValue;
        }
      "
    />
    <popup-ref-formation
      v-else-if="isOF"
      v-show="!isROME"
      :show="showJobDesc"
      :id="shownJobId"
      :opened-from-edit-button="true"
      @mutateShow="
        (newValue) => {
          showJobDesc = newValue;
        }
      "
      @mutateId="
        (newValue) => {
          shownJobId = newValue;
        }
      "
    />
    <popup-fiche-r-o-m-e
      v-show="isROME"
      :show="showJobDesc"
      :id="shownJobId"
      :opened-from-edit-button="true"
      @mutateShow="
        (newValue) => {
          showJobDesc = newValue;
        }
      "
      @mutateId="
        (newValue) => {
          shownJobId = newValue;
        }
      "
    />
    <!-- END Popup to modify or read job desc and ref formation -->

    <!-- BEGIN Popup appear for first connexion after email activation -->
    <popup-activated-account
      :opened="isPopupActivatedAccount"
      @close="changeStateActivatedAccountPopup(false)"
    />
    <!-- END Popup appear for first connexion after email activation -->

    <!-- BEGIN Popup add new neopass -->
    <add-new-neopass-popup
      :add-neopass-display="addNeopassDisplay"
      @close="addNeopassDisplay = -1"
      @open="openPopupNewNeopass"
      @changeStep="
        (numStep) => {
          addNeopassDisplay = numStep;
        }
      "
    />
    <!-- END Popup add new neopass -->

    <!-- BEGIN content dashboard -->
    <div class="lg:mx-5">
      <div class="text-5xl mb-1">
        Bonjour {{ user.firstname }}
      </div>
      <div
        v-if="
          structures.length > 1 &&
            !$freeParticulier() &&
            role != constants.ROLE_BENEFICIAIRE
        "
        class="flex space-x-4 w-full items-center"
      >
        <p class="w-max">
          Choisir la structure :
        </p>
        <input-select
          class="md:w-1/4"
          name="choice_structure"
          :value="structure"
          @input="
            (newValue) => {
              changeStructureAndReloadInfos(newValue.id);
            }
          "
          :datas="structures"
          libelle=""
          :empty-case="false"
          :value-is-object="true"
        />
      </div>
      <div class="text-gray-600 text-2xl font-light mb-20">
        Que souhaitez-vous faire aujourd'hui ?
      </div>
      <!-- BEGIN dashboard grid -->
      <div
        v-if="listPermissions.length > 0"
        class="flex flex-col space-y-10 md:space-y-0 md:h-130 xl:h-150 md:gap-4 xl:gap-8 md:grid md:grid-flow-row md:grid-rows-2 md:grid-cols-3"
      >
        <div
          v-for="(module, km) in listPermissions"
          :key="km"
          :class="{
            'col-span-1': module.position === 1,
            'col-span-2': module.position === 2,
            'col-span-1 row-span-2': module.position === 3,
          }"
        >
          <!-- BEGIN 1st element : Neopass -->
          <neopass-list
            v-if="module.name === constants.MODULE_NEOPASS_FORM"
            :list-neopass="beneficiaries"
            @displayAddNeopassPopup="openPopupNewNeopass()"
            :position="module.position"
          />
          <!-- END 1st element : Neopass -->
          <!-- BEGIN 4th element : Cartographies individuelles/collectives -->
          <collective-cartography
            v-if="module.name === 'collectiveCartography'"
            :datas="gender"
            :position="module.position"
          />
          <individual-cartography
            v-if="module.name === 'individualCartography'"
            :position="module.position"
          />
          <!-- END 4th element : Cartographies individuelles/collectives -->
          <!-- BEGIN 2nd element : Modele de pages -->
          <templates-list
            v-if="module.name === constants.MODULE_MODELE_DE_PAGE"
            :list-page-templates="listPageTemplates"
            :position="module.position"
          />
          <!-- END 2nd element : Modele de pages -->
          <!-- BEGIN 3rd element : Fiches de poste OR Référentiels de formation -->
          <job-description-list
            v-if="module.name === 'jobDescription'"
            :list-descs="listDescs"
            @showJobDesc="(id) => displayJobDesc(id)"
            :position="module.position"
          />
          <help-bloc
            v-if="module.name === 'help'"
            :position="module.position"
          />
        </div>
      </div>
      <div
        v-else
        class="flex flex-col space-y-10 md:space-y-0 md:h-130 xl:h-150 md:gap-4 xl:gap-8 md:grid md:grid-flow-row md:grid-rows-2 md:grid-cols-3"
      >
        <div class="col-span-full text-center">
          <illustration
            class="mx-auto my-5"
            name="notAllowed"
          />
          <span class="text-xl text-pink-600">Vous ne disposez pas des droits vous permettant d'accéder aux
            fonctionnalités du tableau de bord.</span>
          <br><br>

          <span class="text-base">Vous pouvez tout de même accéder aux fonctionnalités dont vous
            disposez des droits d'accès.</span><br><br>

          <span class="text-md text-gray-500 italic">Si vous pensez qu'il s'agit d'une erreur, contactez votre référent
            Neopass.</span>
        </div>
      </div>
      <!-- END dashboard grid -->
    </div>
    <!-- END content dashboard -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import store from './../../store';
import axios from './../../api';
import CollectiveCartographyDatas from '../../mixins/CollectiveCartographyDatas.vue';

import PopupJobDesc from './../../components/PopupJobDesc';
import PopupRefFormation from './../../components/PopupRefFormation';
import PopupActivatedAccount from './popup/PopupActivatedAccount';
import AddNewNeopassPopup from '../../components/NeopassList/AddNewNeopassPopup.vue';

import NeopassList from './../../components/Dashboard/NeopassList';
import TemplatesList from './../../components/Dashboard/TemplatesList';
import JobDescriptionList from './../../components/Dashboard/JobDescriptionList';
import CollectiveCartography from './../../components/Dashboard/CollectiveCartography';
import IndividualCartography from './../../components/Dashboard/IndividualCartography';
import HelpBloc from './../../components/Dashboard/Help';

import InputSelect from './../../components/Inputs/InputSelect.vue';

import Constants from '../../constants';
import PopupFicheROME from '../../components/PopupRomeDesc.vue';
import Illustration from '../../components/Illustration.vue';

export default {
  components: {
    Illustration,
    PopupFicheROME,
    PopupJobDesc,
    PopupRefFormation,
    PopupActivatedAccount,
    NeopassList,
    TemplatesList,
    JobDescriptionList,
    CollectiveCartography,
    IndividualCartography,
    HelpBloc,
    InputSelect,
    AddNewNeopassPopup,
  },

  name: 'Dashboard',

  data() {
    return {
      listDescs: null,
      addNeopassDisplay: -1, // 1: add neopass form / 2: new neopass success / 3: attach neopass success / 4: user not found
      //neopassDatas: {},

      shownJobId: null,
      showJobDesc: false,
      isROME: false,
      saving: false,

      isPopupActivatedAccount: false,
    };
  },

  async mounted() {
    store.commit('app/SET_LOADING', true);
    if (this.role === Constants.ROLE_SUPER_ADMIN) {
      store.commit('app/SET_LOADING', false);
      return;
    }

    if (this.isFirstLogin || !this.user.last_login) {
      this.isPopupActivatedAccount = true;
    }

    this.addLastLogin();

    this.initDatas();
    store.commit('app/SET_LOADING', false);
  },

  methods: {
    ...mapMutations({
      SET_ISFIRSTLOGIN: 'auth/SET_ISFIRSTLOGIN',
      SET_URLCURSOR: 'beneficiaries/SET_URLCURSOR',
    }),

    ...mapActions({
      loadBeneficiaries: 'beneficiaries/loadBeneficiaries',
      load_datas: 'cartographiesCollectives/load_datas',
      changeStructure: 'auth/changeStructure',
    }),

    async initDatas() {
      await this.load_neopass();
      await this.load_descs();
      this.getNextNeopassOnScroll();
    },

    async load_neopass() {
      if (this.$can(Constants.PERMISSION_NEOPASS_PAGE)) {
        this.SET_URLCURSOR('');

        // verify permissions
        await this.loadBeneficiaries({
          hasLoading: true,
          hasPagination: 1,
        });
      }
    },

    /**
     * Pagination with infinite scroll for neopass bloc
     */
    getNextNeopassOnScroll() {
      let mainContent = document.getElementById('neopass-list-dashboard');

      if (!mainContent) {
        return;
      }

      mainContent.onscroll = () => {
        let bottomOfWindow =
          mainContent.scrollTop + mainContent.offsetHeight ===
          mainContent.scrollHeight;

        if (bottomOfWindow) {
          this.nextBeneficiaries();
        }
      };
    },

    nextBeneficiaries() {
      this.loadBeneficiaries({
        hasPagination: 1,
      });
    },

    async load_descs(context) {
      console.log('wait...load descs');
      if (this.isOF) {
        await axios
          .post('/api/sheets/listByType/ref_formation', {
            search: '',
            sector: '',
            family: '',
            wantEvaluationUsed: true,
          })
          .then((response) => {
            this.listDescs = [];
            let datas = response.data;
            this.listDescs = datas.sheets;
          })
          .catch((error) => {
            console.log('ERRRR:: ', error);
          });
      } else if (!this.isOF) {
        await axios
          .post('/api/sheets/listByType/job_desc', {
            search: '',
            sector: '',
            family: '',
            wantEvaluationUsed: true,
          })
          .then((response) => {
            this.listDescs = [];
            let datas = response.data;
            this.listDescs = datas.sheets;
          })
          .catch((error) => {
            console.log('ERRRR:: ', error);
          });
      }
    },

    displayJobDesc(id) {
      this.showJobDesc = true;
      this.shownJobId = id;

      let jobDesc = this.listDescs.find((desc) => desc.id === id);
      this.isROME = jobDesc.type === 'rome';
    },

    openPopupNewNeopass() {
      this.addNeopassDisplay = 1; //add neopass form
      this.saving = false;
      this.errorsNewBeneficiary = '';
    },

    changeStateActivatedAccountPopup(state) {
      this.isPopupActivatedAccount = state;

      if (!state) {
        this.SET_ISFIRSTLOGIN(false);
      }
    },

    async addLastLogin() {
      await axios.get('/api/addLastLogin').then((response) => {
        this.user.last_login = response.data.last_login;
        //store.dispatch('auth/me') => when I add this line, page reload when user has many structures
      });
    },

    async changeStructureAndReloadInfos(idStructure) {
      await this.changeStructure(idStructure);
      this.$router.go();
    },
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      listModules: 'template/listModulesPages',
      role: 'auth/role',
      isFirstLogin: 'auth/isFirstLogin',
      permissions: 'auth/permissions',
      beneficiaries: 'beneficiaries/beneficiaries',
      structure: 'auth/structure',
    }),
    constants: function () {
      return Constants;
    },

    listPermissions() {
      let list = [];

      if (
        this.$can(Constants.PERMISSION_NEOPASS_PAGE) ||
        (this.$can(Constants.PERMISSION_NEOPASS_FORM_PAGE) &&
          (this.role == Constants.ROLE_BENEFICIAIRE || this.$freeParticulier()))
      ) {
        list.push({ name: Constants.MODULE_NEOPASS_FORM, position: 0 });
      }

      if (
        this.$can(Constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_DISPLAY) &&
        this.role != Constants.ROLE_BENEFICIAIRE
      ) {
        list.push({ name: 'collectiveCartography', position: 0 });
      }
      if (
        this.$can(Constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_DISPLAY) &&
        ((this.role === Constants.ROLE_BENEFICIAIRE) ||
          this.$freeParticulier())
      ) {
        list.push({ name: 'individualCartography', position: 0 });
      }



      if (
        (this.$can(Constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_CONSULTER) ||
          this.$can(Constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_EDITER)) &&
        !this.isOF
      ) {
        list.push({ name: 'jobDescription', position: 0 });
      }

      if (
        (this.$can(
          Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_CONSULTER
        ) ||
          this.$can(
            Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER
          )) &&
        this.isOF
      ) {
        list.push({ name: 'refFormation', position: 0 });
      }

      if (this.$can(Constants.PERMISSION_AIDE_PAGE) && list.length < 4) {
        // Module Aide n'apparait que si le total fait 4 au plus
        list.push({ name: 'help', position: 0 });
      }

      let dispositif = [];
      switch (list.length) {
      case 1:
        dispositif = [2];
        break;
      case 2:
        dispositif = [2, 2];
        break;
      case 3:
        dispositif = [2, 3, 2];
        break;
      case 4:
        dispositif = [2, 3, 1, 1];
        break;
      case 5:
        dispositif = [1, 1, 1, 1, 3];
        break;
      case 6:
        dispositif = [1, 1, 1, 1, 1, 1];
        break;
      }

      dispositif.forEach((bloc, index) => {
        list[index].position = bloc;
      });

      return list;
    },

    //data generation for Collective Cartography bloc
    ...CollectiveCartographyDatas.computed,

    listPageTemplates() {
      if (this.listModules != null) {
        //Keep only module with page associated with page template
        let listPageTemplates = this.listModules
          .map((module) =>
            module.pages.filter((page) => page.templates.length > 0)
          ) //keep only modules with page templates
          .filter((module) => module.length > 0) //Delete array case without value
          .map((module, i) =>
            module.map((page, j) =>
              page.templates.map((page_template) => ({
                ...page_template,
                page_name: page.name,
                module_name: this.listModules[i].name,
              }))
            )
          ) //add page_name and module_name values for the router-link
          .reduce(
            (acc1, module) => [
              ...acc1,
              ...module.reduce(
                (acc2, page) => [
                  ...acc2,
                  ...page.reduce(
                    (acc3, page_template) => [...acc3, page_template],
                    []
                  ),
                ],
                []
              ),
            ],
            []
          ); //list all pages template in one dimension array

        return listPageTemplates;
      } else {
        return [];
      }
    },

    isOF() {
      return (
        !this.role === Constants.ROLE_SUPER_ADMIN &&
        this.structure.type === Constants.TYPE_OF
      );
    },

    structures() {
      return (this.user.companies || []).reduce(
        (acc, company) => [...acc, { ...company, value: company.name }],
        []
      );
    },
  },
};
</script>
